module.exports = __webpack_public_path__ + "yz/img/ewm.ca406d53.jpg";